import { Navigate, RouteObject, useRoutes, Outlet } from 'react-router-dom';
import {
  CSAuthSessionContainer,
  CSAuthSignIn,
  CSAuthSignOut,
} from '@highmark-web/highmark-common';
import { MemberDetailsPage } from 'pages/member-details/member-details.page';
import { MemberSearchPage } from 'pages/member-search/member-search.page';
import { PrivateBasePage } from 'components/private-base-page/private-base-page.component';
import { isMockMode } from 'utils/mock-mode';
import { APP_ROUTES } from './constants';

const SessionContainer = () =>
  isMockMode() ? <Outlet /> : <CSAuthSessionContainer />;

const routes: RouteObject[] = [
  { path: APP_ROUTES.SIGN_IN, element: <CSAuthSignIn /> },
  { path: APP_ROUTES.SIGN_OUT, element: <CSAuthSignOut /> },
  {
    path: '',
    element: <SessionContainer />,
    children: [
      {
        path: '',
        element: <PrivateBasePage />,
        children: [
          { path: APP_ROUTES.MEMBER_SEARCH, element: <MemberSearchPage /> },
          {
            path: APP_ROUTES.MEMBER_DETAILS,
            element: <MemberDetailsPage />,
          },
          {
            path: '',
            element: <Navigate to={APP_ROUTES.MEMBER_SEARCH} replace />,
          },
        ],
      },
    ],
  },
];

export const AppRoutes = () => useRoutes(routes);
